import React from "react";
import Bars from "../graphics/containers/CleanBarDB";
import { colors4 } from "../../constants/icons/characteristics/Characteristics";

function barChartComponent(props) {

  const { data } = props;
  const dataGrafica = data ? data[0] : { dataSet: [] };
  if (dataGrafica.dataSet.length === 0) return <></>;
  const tratamiento = dataGrafica.dataSet.filter(f => f.name).sort((a, b) => b - a).slice(0, 5);

  return (
    <>
      <Bars
        name={dataGrafica.key} 
        title={dataGrafica.pregunta}
        data={tratamiento}
        date={null}
        colors={colors4}
        openDialog={false}
        watchMenu={false}
        seeMore={false}
      />
    </>
  );
}

export default barChartComponent;
